import ENV from "../.env";

export const APP_CONFIGS = {
    ADMIN_IDENTIFIER: 'ADMIN',
    APP_ENV: ENV.APP_ENV,
    API_BASE: ENV.API_BASE,
    API_SCOPE: ENV.API_SCOPE,

    // AD Authentication
    AUTHORITY: ENV.AUTHORITY,
    CLIENT_ID: ENV.CLIENT_ID,
    REDIRECT_URL: ENV.REDIRECT_URL,

    // User Cookie
    USER_SESSION_KEY: 'TClockUser',
    USER_FACTORIES_SESSION_KEY: 'TClockUserFactories',

    // APIM Key
    APIM_SUBSCRIPTION_KEY: ENV.APIM_SUBSCRIPTION_KEY,

    // App User Agent Config
    TULITA_APP_USER_AGENT: 'TULITA_ANDROID'
}